import React, { Component } from "react";
import { Link } from "react-router-dom";

import { hostname, path } from "../../config";

class CustomLink extends Component {
  render() {
    const { noclick } = this.props;
    let needRedirect = false;
    if (window.location.hostname !== hostname) {
      needRedirect = true;
    }

    return noclick ? (
      <div {...this.props}>{this.props.children}</div>
    ) : needRedirect ? (
      <a href={path + this.props.to} {...this.props}>
        {this.props.children}
      </a>
    ) : (
      <Link {...this.props}>{this.props.children}</Link>
    );
  }
}

export default CustomLink;
